import './App.css';
import Home from './pages/home';
import Backlog from './pages/backlog';
import Projects from './pages/project';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";


function App() {
  return (
    <>
      <Router>
        <Routes>
         <Route path="/" element={<Home/>} />
         <Route path="/backlog" element={<Backlog/>} />
         <Route path="/projects" element={<Projects/>}/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
